import { DayNumber, DefaultSchedulingSettings, EntityCalendarWorkingHours } from '@jms/model';
import { GeneralSettingService } from '@jms/ui/ui.standalone.services/general.setting.service';
import type { EntityManifestCalendar } from '@workbuddy/services/entities/entity.manifest.calendar';

export const allocationResourceAvailability: NonNullable<EntityManifestCalendar['resourceAvailability']> = context => {
  const settings = context.injector.get(GeneralSettingService).$generalSettings()?.schedule;
  const schedules = new Map<string, EntityCalendarWorkingHours>();
  if (!settings) return schedules;
  for (const resource of context.resources) {
    const ref = resource.extendedProps?.['ref'] as { scheduling?: { timezone?: string } } | undefined;
    if (!ref) continue; // Group headings and Unassigned have no contact availability.
    schedules.set(resource.id, {
      timezone: ref.scheduling?.timezone ?? context.calendar.timezone ?? settings.timezones?.[0] ?? 'UTC',
      daysOfWeek: settings.workWeek?.map(DayNumber) ?? [1, 2, 3, 4, 5],
      startTime: settings.dayStartTime ?? DefaultSchedulingSettings.dayStartTime,
      endTime: settings.dayEndTime ?? DefaultSchedulingSettings.dayEndTime,
    });
  }
  return schedules;
};
